$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p == "events") {
    let pos_sub_product_category_modal_lock = false;
    //new
    $(document).on(
      "click.subCategory",
      ".sub_product_category_card_btn",
      function (e) {
        e.stopPropagation();
        // let locationId = $("body").attr("event_id");
        // Get data from button attributes
        // Get data from button attributes using attr() for complex JSON data
        var subProductCategoryId = $(this).data("sub-product-category-id");
        var locationType = $(this).data("location-type");
        var numberOfProductsInCart = $(this).data("number-of-products-in-cart");
        var organizerId = $(this).data("organizer-id");
        var locationId = $(this).data("location-id");

        // Debug: log the data to console

        // Call the modal function with extracted data
        getPosSubProductCategoryModal(
          subProductCategoryId,
          locationType,
          numberOfProductsInCart,
          organizerId,
          locationId,
        );
      },
    );

    function getPosSubProductCategoryModal(
      subProductCategoryId,
      locationType,
      numberOfProductsInCart,
      organizerId,
      locationId,
    ) {
      if ($("#pos-sub-product-category-product-modal").length) {
        $("#pos-sub-product-category-product-modal").remove();
      }
      if (!pos_sub_product_category_modal_lock) {
        pos_sub_product_category_modal_lock = true;
        $.ajax({
          type: "POST",
          url: "/ajax/events/get_pos_sub_category_modal",
          data: {
            sub_product_category_id: subProductCategoryId,
            location_type: locationType,
            number_of_products_in_cart: numberOfProductsInCart,
            organizer_id: organizerId,
            location_id: locationId,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $("#content").append(data.html);
              $("#pos-sub-product-category-product-modal").modal("show");
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            pos_sub_product_category_modal_lock = false;
          })
          .always(function () {
            pos_sub_product_category_modal_lock = false;
          });
      }
      return false;
    }
  }
});
